import { useCallback, type Dispatch, type SetStateAction } from "react";
import type { AgentOption } from "@/hooks/use-comment-action";
import type { ImageAttachment } from "@/components/panels/image-preview-strip";

interface DemoSubmitPopover {
  frameId: string;
  submitMode?: "onboarding_demo_suppress";
  submitEventName?: string;
  demoAgent?: AgentOption;
}

interface UseCommentPopoverDemoSubmitOptions {
  popoverReady: boolean;
  popover: DemoSubmitPopover | null;
  text: string;
  selectedAgent: AgentOption | null;
  setAttachedImages: Dispatch<SetStateAction<ImageAttachment[]>>;
  closePopover: () => void;
}

export function useCommentPopoverDemoSubmit({
  popoverReady,
  popover,
  text,
  selectedAgent,
  setAttachedImages,
  closePopover,
}: UseCommentPopoverDemoSubmitOptions): () => boolean {
  return useCallback((): boolean => {
    if (
      !popoverReady ||
      !popover ||
      popover.submitMode !== "onboarding_demo_suppress"
    ) {
      return false;
    }
    if (popover.submitEventName) {
      window.dispatchEvent(
        new CustomEvent(popover.submitEventName, {
          detail: {
            frameId: popover.frameId,
            text,
            agentId: selectedAgent?.id ?? popover.demoAgent?.id,
          },
        }),
      );
    }
    setAttachedImages([]);
    closePopover();
    return true;
  }, [
    popoverReady,
    popover,
    text,
    selectedAgent,
    setAttachedImages,
    closePopover,
  ]);
}
